import { z } from 'zod'

export const ACCOUNT_FORM_FIELDS = ['bankName', 'bankAccount', 'accountHolder']

export const ZAccountFormValues = z.object({
  bankName: z.string().trim().min(1, {
    message: '은행을 선택해 주세요.',
  }),
  bankAccount: z.string().trim().min(1, {
    message: '계좌번호를 입력해 주세요.',
  }),
  accountHolder: z.string(),
})

export type TAccountFormValues = z.infer<typeof ZAccountFormValues>

export const accountFormDefaultValues = {
  bankName: '',
  bankAccount: '',
  accountHolder: '',
}
